import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getSlot as o } from "../../shared/v-node.js";
import r from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-false-until-truthy.js";
import { toRef as l } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { defineComponent as s, computed as i, h as d, Teleport as n } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const f = s({
  name: "LazyTeleport",
  props: {
    to: {
      type: [String, Object],
      default: void 0
    },
    disabled: Boolean,
    show: {
      type: Boolean,
      required: !0
    }
  },
  setup(t) {
    return {
      showTeleport: r(l(t, "show")),
      mergedTo: i(() => {
        const { to: e } = t;
        return e != null ? e : "body";
      })
    };
  },
  render() {
    return this.showTeleport ? this.disabled ? o("lazy-teleport", this.$slots) : d(n, {
      disabled: this.disabled,
      to: this.mergedTo
    }, o("lazy-teleport", this.$slots)) : null;
  }
});
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/lazy-teleport/src/index.js
// module id = 480
// module chunks = 41